import http from '@/biz/http.mjs'

export default {
    readList: args => http.get('/omoo/listOoOr', args),
}
